var map = {
	"./Deutsch.png": 6605,
	"./English.png": 5315,
	"./Español.png": 1652,
	"./Français.png": 7504,
	"./Italiano.png": 3810,
	"./Nederlands.png": 2333,
	"./Nederlands_Ned.png": 5925,
	"./Origin/break.png": 9894,
	"./Origin/break_done.png": 9083,
	"./Origin/break_nomeal.png": 1850,
	"./Türkçe.png": 5577,
	"./csam.png": 7263,
	"./csam2.png": 5104,
	"./csam3.png": 599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;